import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { CatalogPreview } from 'modules/domains';
import {
  selectCatalogPreviewsLoading,
  selectCatalogPreviews,
} from 'modules/catalog/catalogPreview';
import PreviewResultsTable from 'modules/catalog/collectionBuilder/components/previewResultsTable';
import { useCatalogPreviewFieldMappings } from 'modules/catalog/hooks/useCatalogPreviewFieldMappings';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';
import { useGetCatalogQuery } from './hooks/useGetCatalogQuery';
import { useTranslation } from '../hooks';

export const DATA_TEST = {
  table: 'catalog-preview-table',
  headerContent: 'table-header-content',
};

const HeaderContent = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

const catalogPreviewLimit = 20;
const truncateCatalogPreviews = (catalogPreviews: CatalogPreview[] = []) =>
  catalogPreviews.slice(0, catalogPreviewLimit) as [];

export const CatalogPreviewTable = () => {
  const { t } = useTranslation();
  const catalogQuery = useGetCatalogQuery();
  const { isOpen } = useCatalogPreviewContext();
  const isCatalogPreviewLoading = useSelector(selectCatalogPreviewsLoading);
  const catalogPreviews = useSelector(selectCatalogPreviews);
  const { data: fieldMappings, isLoading: isCatalogFieldsLoading } = useCatalogPreviewFieldMappings(
    catalogQuery?.catalogName,
  );
  const previewLimitMessage = t('catalogQuery.previewLimitMessage', { count: 20 });

  return (
    <div data-test={DATA_TEST.table}>
      <PreviewResultsTable
        headerContent={
          <HeaderContent data-test={DATA_TEST.headerContent}>{previewLimitMessage}</HeaderContent>
        }
        rows={truncateCatalogPreviews(catalogPreviews)}
        didPreviewData={isOpen}
        isLoading={isCatalogPreviewLoading || isCatalogFieldsLoading}
        fieldTypes={fieldMappings}
      />
    </div>
  );
};
